import {PaymentCodeEnum, PayoutWebModel} from "capitalist-shared/src/finance/payments";

export class IMPSPayoutModel extends PayoutWebModel {
  systemName = PaymentCodeEnum.IMPS

  required = [
    'amount', 'description', 'fromAccount', 'destinationAccount',
    'accountName', 'bankCode',
    'verificationType', 'label'
  ]

  values = {
    fromAccount: '', amount: '', label: '',
    accountName: '', bankCode: '',
    verificationType: '', autosplit: false, destinationAccount: ''
  }
}
